import { c } from '../../../utils/tailwind-merge';
import { InboxFooter } from '../../molecules/InboxFooter';
import { InboxHeader } from '../../molecules/InboxHeader';
import { NotificationEmptyContent } from '../../molecules/NotificationEmptyContent';
import { NotificationItem } from '../../molecules/NotificationItem';
import { InboxProps } from './Inbox.types';

export const Inbox = ({
  header,
  notifications,
  microcopy,
  className = '',
  onMarkAllAsRead,
  onSettingsClick,
  onNotificationItemClick,
}: InboxProps) => {
  return (
    <div
      className={c(
        'flex h-full max-h-[650px] w-full flex-col bg-grey-900',
        className
      )}
    >
      <InboxHeader
        {...header}
        microcopy={microcopy.header}
        onMarkAllAsRead={onMarkAllAsRead}
      />

      <div className="h-full overflow-y-auto">
        {notifications.length === 0 ? (
          <NotificationEmptyContent microcopy={microcopy.empty} />
        ) : (
          notifications.map((notification) => (
            <NotificationItem
              {...notification}
              key={notification.id}
              onNotificationItemClick={onNotificationItemClick}
            />
          ))
        )}
      </div>

      <InboxFooter
        microcopy={microcopy.footer}
        onSettingsClick={onSettingsClick}
      />
    </div>
  );
};
